import { redirect } from 'react-router-dom'
import Icon from '@mui/material/Icon'
import CompaniesPage from './components/companies/CompaniesPage'
import CompanyForm from './pages/company-form/companyForm'
import EntriesPage from './components/entries/EntriesPage'
import EntryPage from './components/entries/EntryPage'
import DocumentEditorPage from './components/editors/DocumentEditorPage'
import { fetchAnnouncementForBreadcrumb, fetchDocumentForBreadcrumb, fetchMinimalCompanyInfo } from './helpers/fetch.helper'
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import SignIn from 'pages/auth/sign-in/sign-in.component'
import AuthWrapper from 'components/auth/AuthWrapper'
import AuthStorage from './units/auth/AuthStorage'
import ActivePage from './pages/active/ActivePage'
import JournalPage from './components/journal/JournalPage'
import AnnouncementsPage from './components/announcements/AnnouncementsPage'
import AnnouncementEditorPage, { NEW_ANNOUNCEMENT } from './components/announcements/AnnouncementEditorPage'
import AnnouncementStatsPage from './components/announcements/AnnouncementStatsPage'
import FirmsPage from './components/firms/FirmsPage'
import FirmPage from './components/firms/FirmPage'
import FirmSettingsPage from './components/firms/FirmSettingsPage'
import UsersPage from './components/users/UsersPage'
import UserPage from './components/users/UserPage'
import EmailPage from './components/email/EmailPage'
import EmailRecordPage from './components/email/EmailRecordPage'
import TestEmailPage from './components/email/TestEmailPage'
import RepliesPage from './components/replies/RepliesPage'
import ReplyPage from './components/replies/ReplyPage'
import UnsubscribePage from './pages/public/UnsubscribePage'

const routes = [
    {
        element: <AuthWrapper />,
        children: [
            {
                path: '/',
                element: <DashboardLayout />,
                handle: {
                    icon: 'home',
                    title: <Icon>home</Icon>,
                    crumb: true,
                },
                children: [
                    {
                        index: true,
                        loader: async () => {
                            return redirect('/companies')
                        },
                    },
                    {
                        path: 'companies',
                        children: [
                            {
                                element: <CompaniesPage />,
                                index: true,
                                id: 'companies',
                                handle: {
                                    title: 'החברות שלי',
                                    icon: 'store',
                                    nav: true,
                                    crumb: true,
                                },
                            },
                            {
                                path: ':companyId',
                                element: <CompanyForm />,
                                handle: {
                                    key: 'company',
                                    getTitle: async ({ companyId }) => {
                                        const authStorage = new AuthStorage()

                                        let company
                                        if (!authStorage.isAuthenticated()) {
                                            company = null
                                        }
                                        else {
                                            company = await fetchMinimalCompanyInfo(companyId)
                                        }
                                        return company?.companyName || 'ללא שם'
                                    },
                                    crumb: true,
                                },
                            },
                            // {
                            //   path: 'add',
                            //   element: <CompanyForm mode="create" />,
                            //   handle: {
                            //     key: 'company-add',
                            //     title: 'חברה חדשה',
                            //   },
                            // },
                            {
                                path: ':companyId/entries',
                                element: <EntriesPage />,
                                handle: {
                                    key: 'company-entries',
                                    title: 'רשומות',
                                    // getTitle: async (params) => {
                                    //   const company = await fetchOneCompany(params.companyId)
                                    //   return company?.companyName || '?'
                                    // },
                                    crumb: true,
                                },
                            },
                            {
                                path: ':companyId/entries/:entryId',
                                element: <EntryPage />,
                                handle: {
                                    key: 'company-entry',
                                    getTitle: async ({ entryId }) => {
                                        return `רשומה ${entryId}`
                                    },
                                    crumb: true,
                                },
                                children: [
                                    {
                                        path: 'documents/:documentId',
                                        // element: <DocumentPage mode="view" />,
                                        element: <DocumentEditorPage editMode={false} />,
                                        handle: {
                                            key: 'company-entry-document',
                                            getTitle: async (params) => {
                                                const { documentId } = params
                                                let documentName = 'מסמך'
                                                try {
                                                    const document = await fetchDocumentForBreadcrumb(documentId)
                                                    const kind = document?.kind
                                                    if (kind === 'check') {
                                                        documentName = 'שיק'
                                                    }
                                                    else if (kind === 'voucher') {
                                                        documentName = 'שובר'
                                                    }
                                                }
                                                catch (error) {
                                                    console.error(error)
                                                }
                                                return `${documentName} ${documentId}`
                                            },
                                            crumb: true,
                                        },
                                        // children: [
                                        //   {
                                        //     path: 'edit',
                                        //     element: <DocumentEditorPage mode="edit" />,
                                        //     handle: {
                                        //       title: 'עריכה',
                                        //     },
                                        //     crumb: true,
                                        //   },
                                        // ],
                                        // editMode: false,
                                    },
                                    //   {
                                    //     key: 'company-entry-document',
                                    //     path: 'documents/add/:documentId',
                                    //     element: <DocumentEditorPage />,
                                    //     editMode: false,
                                    //   },
                                    //   {
                                    //     key: 'company-entry-document-edit',
                                    //     path: 'documents/edit/:documentId',
                                    //     element: <DocumentEditorPage />,
                                    //     editMode: true,
                                    //   },
                                ],
                            },
                        ],
                    },
                    {
                        path: 'journal',
                        children: [
                            {
                                element: <JournalPage />,
                                index: true,
                                id: 'journal',
                                handle: {
                                    title: 'יומן',
                                    icon: 'receipt_long',
                                    nav: true,
                                    crumb: true,
                                },
                            },
                        ],
                    },
                    {
                        path: 'announcements',
                        children: [
                            {
                                element: <AnnouncementsPage />,
                                index: true,
                                id: 'announcements',
                                handle: {
                                    title: 'מודעות',
                                    icon: 'campaign',
                                    crumb: true,
                                },
                            },
                            {
                                // Element-less on purpose: React Router renders an
                                // Outlet here, which is what lets both children sit
                                // under the announcement's own breadcrumb.
                                path: ':documentId',
                                handle: {
                                    key: 'announcement',
                                    getTitle: async ({ documentId }) => {
                                        if (documentId === NEW_ANNOUNCEMENT) {
                                            return 'מודעה חדשה'
                                        }

                                        const authStorage = new AuthStorage()
                                        if (!authStorage.isAuthenticated()) {
                                            return 'מודעה'
                                        }

                                        const announcement = await fetchAnnouncementForBreadcrumb(documentId)
                                        return announcement?.name || 'ללא שם'
                                    },
                                    crumb: true,
                                },
                                children: [
                                    {
                                        index: true,
                                        element: <AnnouncementEditorPage />,
                                    },
                                    {
                                        path: 'stats',
                                        element: <AnnouncementStatsPage />,
                                        handle: {
                                            title: 'נתונים',
                                            crumb: true,
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        path: 'firms',
                        children: [
                            {
                                element: <FirmsPage />,
                                index: true,
                                id: 'firms',
                                handle: {
                                    title: 'משרדים',
                                    icon: 'business',
                                    crumb: true,
                                },
                            },
                            {
                                path: ':firmId',
                                element: <FirmPage />,
                                handle: {
                                    key: 'firm',
                                    getTitle: async () => 'משרד',
                                    crumb: true,
                                },
                            },
                        ],
                    },
                    {
                        path: 'users',
                        children: [
                            {
                                element: <UsersPage />,
                                index: true,
                                id: 'users',
                                handle: {
                                    title: 'משתמשים',
                                    icon: 'group',
                                    crumb: true,
                                },
                            },
                            {
                                path: ':userId',
                                element: <UserPage />,
                                handle: {
                                    key: 'user',
                                    title: 'משתמש',
                                    crumb: true,
                                },
                            },
                        ],
                    },
                    {
                        path: 'firm-settings',
                        children: [
                            {
                                element: <FirmSettingsPage />,
                                index: true,
                                id: 'firm-settings',
                                handle: {
                                    title: 'הגדרות המשרד',
                                    icon: 'settings',
                                    crumb: true,
                                },
                            },
                        ],
                    },
                    {
                        path: 'emails',
                        children: [
                            {
                                element: <EmailPage />,
                                index: true,
                                id: 'email',
                                handle: {
                                    title: 'דואר יוצא',
                                    icon: 'mail',
                                    crumb: true,
                                },
                            },
                            // Ahead of :emailId so that the router cannot read "test" as
                            // an email id, mirroring the server's route order.
                            {
                                path: 'test',
                                element: <TestEmailPage />,
                                handle: {
                                    key: 'test-email',
                                    title: 'בדיקת דואר',
                                    crumb: true,
                                },
                            },
                            {
                                path: ':emailId',
                                element: <EmailRecordPage />,
                                handle: {
                                    key: 'email-record',
                                    title: 'הודעה',
                                    crumb: true,
                                },
                            },
                        ],
                    },
                    {
                        path: 'replies',
                        children: [
                            {
                                element: <RepliesPage />,
                                index: true,
                                id: 'replies',
                                handle: {
                                    title: 'תגובות',
                                    icon: 'forum',
                                    crumb: true,
                                },
                            },
                            {
                                path: ':replyId',
                                element: <ReplyPage />,
                                handle: {
                                    key: 'reply',
                                    title: 'תגובה',
                                    crumb: true,
                                },
                            },
                        ],
                    },
                    // {
                    //     path: 'active',
                    //     children: [
                    //         {
                    //             element: <ActivePage />,
                    //             index: true,
                    //             id: 'active',
                    //             handle: {
                    //                 title: 'רשומות פעילות',
                    //                 icon: 'checklistrtl',
                    //                 nav: true,
                    //                 crumb: true,
                    //             },
                    //         },
                    //     ]
                    // }
                ],
            },
        ],
    },
    // Outside AuthWrapper on purpose: the recipient acting on an unsubscribe link has no
    // account, and sending them to sign-in would make the link unusable.
    {
        path: '/unsubscribe/:token',
        element: <UnsubscribePage />,
        id: 'unsubscribe',
    },
    {
        path: '/auth',
        // element: <IllustrationLayout />,
        children: [
            {
                index: true,
                loader: async () => {
                    return redirect('/auth/sign-in')
                },
            },
            {
                path: 'sign-in',
                element: <SignIn />,
                id: 'auth-sign-in',
            },
        ],
    },
]
export default routes
